webpackJsonp([281194515324988],{

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _glamor = __webpack_require__(73);
	
	var _gatsbyLink = __webpack_require__(27);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(26);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var columnisePhotos = function columnisePhotos(photos) {
		var columnCount = 3;
		var columnHeights = Array(columnCount).fill(0);
		var columns = columnHeights.map(function (i) {
			return [];
		});
	
		var selectShortestIdx = function selectShortestIdx() {
			var shortestIdx = 0;
			for (var i = 1; i < columnCount; i++) {
				if (columnHeights[i] < columnHeights[shortestIdx]) {
					shortestIdx = i;
				}
			}
			return shortestIdx;
		};
	
		photos.forEach(function (photo) {
			var idx = selectShortestIdx();
			columns[idx].push(photo);
			columnHeights[idx] += photo.resolutions.height;
		});
		return columns;
	};
	
	var Gallery = function Gallery(_ref) {
		var photos = _ref.photos;
		return Glamor.createElement(
			"div",
			{ css: { display: "flex" } },
			columnisePhotos(photos).map(function (column, i) {
				return Glamor.createElement(
					"div",
					{ key: i, css: [(0, _glamor.select)("& + &", { marginLeft: 9 })] },
					column.map(function (p) {
						return Glamor.createElement(_gatsbyImage2.default, { key: p.key, resolutions: p.resolutions });
					})
				);
			})
		);
	};
	
	var query = exports.query = "** extracted graphql fragment **";
	
	var dataToPhotos = function dataToPhotos(data) {
		return data.allFile.edges.map(function (_ref2) {
			var _ref2$node = _ref2.node,
			    name = _ref2$node.name,
			    resolutions = _ref2$node.childImageSharp.resolutions;
			return {
				key: name,
				resolutions: resolutions
			};
		});
	};
	
	var Handcraft = function Handcraft(_ref3) {
		var data = _ref3.data;
		return Glamor.createElement(
			"div",
			null,
			Glamor.createElement(
				"div",
				{ css: { margin: "0 0.5rem" } },
				Glamor.createElement(
					_gatsbyLink2.default,
					{ css: { float: "right" }, to: "/" },
					"Back"
				),
				Glamor.createElement(
					"h3",
					null,
					"Pottery"
				)
			),
			Glamor.createElement(Gallery, { photos: dataToPhotos(data) })
		);
	};
	
	exports.default = Handcraft;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-handcraft-js-c8de2df7407431b8fd6d.js